import { UserProfile } from './program/user-profile';

export class AccountSettings {
  avatar: string;
  disable_all_emails: boolean;
  first_name: string;
  last_name: string;
  profile: UserProfile[];
  password?: string;
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/models/account-settings.ts